export default __webpack_public_path__ + "static/media/NeueMontreal-Italic.e5d27a6c.woff";